import { useState } from 'react';
import { generateUnifiedPDF, generateSearchEvidencePDF, createDigipinSearchRecord } from '../utils/pdfGenerator';

export const usePdfGeneration = () => {
  const [isLoading, setIsLoading] = useState({});
  const [error, setError] = useState(null);

  const generatePDF = async (searchRecord, recordId) => {
    setIsLoading(prev => ({ ...prev, [recordId]: true }));
    setError(null);
    
    try {
      await generateSearchEvidencePDF(searchRecord);
    } catch (error) {
      setError('PDF generation failed');
    } finally {
      setIsLoading(prev => ({ ...prev, [recordId]: false }));
    }
  };

            const generateUnifiedPDFWrapper = async (data, options, recordId) => {
            setIsLoading(prev => ({ ...prev, [recordId]: true }));
            setError(null);

            try {
              // Remove googleApiKey from options since it's not needed
              const { googleApiKey, ...cleanOptions } = options;
              await generateUnifiedPDF(data, cleanOptions);
            } catch (error) {
              setError('PDF generation failed');
            } finally {
              setIsLoading(prev => ({ ...prev, [recordId]: false }));
            }
          };

  const generateDigipinPDF = async (searchRecord, recordId) => {
    setIsLoading(prev => ({ ...prev, [recordId]: true }));
    setError(null);
    
    try {
      await generateSearchEvidencePDF(searchRecord);
    } catch (error) {
      setError('Digipin PDF generation failed');
    } finally {
      setIsLoading(prev => ({ ...prev, [recordId]: false }));
    }
  };

  const generateRoutePDF = async (searchRecord, recordId) => {
    setIsLoading(prev => ({ ...prev, [recordId]: true }));
    setError(null);
    
    try {
      await generateSearchEvidencePDF(searchRecord);
    } catch (error) {
      setError('Route PDF generation failed');
    } finally {
      setIsLoading(prev => ({ ...prev, [recordId]: false }));
    }
  };

  const createSearchRecord = (data, userEmail) => {
    return {
      id: `search_${Date.now()}`,
      search_input: data.address || data.digipin || 'Unknown',
      address: data.address || '',
      digipin: data.digipin || '',
      latitude: data.lat || data.latitude || null,
      longitude: data.lng || data.longitude || null,
      country_code: 'IN',
      country_name: 'India',
      search_type: 'search',
      user_email: userEmail,
      timestamp: new Date().toISOString()
    };
  };

  const createDigipinSearchRecord = (data, userEmail) => {
    return {
      id: `digipin_${Date.now()}`,
      search_input: data.address || data.digipin || 'Unknown',
      address: data.address || '',
      digipin: data.digipin || '',
      latitude: data.lat || data.latitude || null,
      longitude: data.lng || data.longitude || null,
      country_code: 'IN',
      country_name: 'India',
      search_type: 'digipin',
      user_email: userEmail,
      timestamp: new Date().toISOString()
    };
  };

  return {
    generatePDF,
    generateUnifiedPDF: generateUnifiedPDFWrapper,
    generateDigipinPDF,
    generateRoutePDF,
    createSearchRecord,
    createDigipinSearchRecord,
    isLoading: (recordId) => isLoading[recordId] || false,
    error
  };
};
